module.exports = __webpack_public_path__ + "e6313f2797d12c699d4153c11616de6f.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/wasistgoldencity4.jpg
// module id = 504
// module chunks = 0